/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Record from 'fierry/data/record';
import Time from 'fierry/util/time';


const SERVER_DELAY_MAX = 5 * Time.getSecondTicks();


export default class CurrentTime extends Record
{
  static getInitialState (cass)
  {
    const now = Date.now();

    return super.getInitialState({ ...cass, clientDelay: now - cass.clientDate, serverDelay: now - cass.serverDate });
  }


  getClientDate (now)
  {
    if (!this.cass)
    {
      return now ?? Date.now();
    }

    return now ? now - this.cass.clientDelay : this.cass.clientDate;
  }


  getServerDate (now)
  {
    if (!this.cass)
    {
      return now ?? Date.now();
    }

    return now ? now - this.cass.serverDelay : this.cass.serverDate;
  }


  isRealTime ()
  {
    return this.cass ? this.cass.realtime === true : true;
  }


  getServerDelay ()
  {
    if (!this.cass)
    {
      return 0;
    }

    return this.getClientDate() - this.getServerDate();
  }


  isServerDelayed ()
  {
    return this.getServerDelay() >= SERVER_DELAY_MAX;
  }


};
